<div>
    <h5 class="m-t-15">
      <span>{{ question.name }}</span>
    </h5>
  </div>
<div class="m-l-20 table-responsive">
<table class="table borderless">
    <thead>
      <tr class="d-flex">
        <th class="p-l-0" width="170" scope="col"></th>
        <th width="100" class="p-l-0" style="width: 100px;max-width: 100px;" *ngFor="let column of answerColumns" scope="col">{{ column.name }}</th>
      </tr>
    </thead>
    <tbody>
      <tr class="d-flex" *ngFor="let row of answerRows">
        <th class="p-l-0 text-left" width="170" scope="row">{{ row.name }}</th>
       <td class="p-l-0" width="100" *ngFor="let column of answerColumns">
         <i [ngClass]="(getIsMatrixCheckbox())?'ti-layout-width-full':'fa fa-circle-thin'"></i>
        </td> 
      </tr>
    </tbody>
  </table>
</div>